module.exports = __webpack_public_path__ + "img/JT-7-4-3-6c-no35.1d3bb2c8.jpg";